import { FormattedMessage } from 'react-intl';

import { useEditStore } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { IconInfo } from '@xing-com/icons';

import { EditBarBack } from '../edit-bar-back/edit-bar-back';
import { ToggleEditMode } from '../toggle-edit-mode/toggle-edit-mode';

import * as Styled from './edit-bar.styles';

type EditBarMobileProps = {
  displayBackButton: boolean;
};
export const EditBarMobile: React.FC<EditBarMobileProps> = ({
  displayBackButton,
}) => {
  const isEditing = useEditStore(({ isEditing }) => isEditing);

  return (
    <Styled.EditBarMobile data-testid="edit-bar-mobile">
      <Styled.BannerMobileContainer>
        <Styled.BannerMobile>
          {displayBackButton ? (
            <Styled.BackButtonContainer>
              <EditBarBack />
            </Styled.BackButtonContainer>
          ) : null}
          <div className="ctaContainer">
            <ToggleEditMode />
          </div>
          <Styled.LabelContainer>
            <IconInfo height={24} width={24} className="editMobileIcon" />
            <Styled.MobileInfo size="small">
              <span data-testid="edit-bar-mobile-label">
                <FormattedMessage
                  id={
                    isEditing
                      ? 'EP_EDIT_INFO_EDIT_VIEW'
                      : 'EP_EDIT_INFO_VISITOR_VIEW'
                  }
                  values={{
                    span: (msg) => <span>{msg}</span>,
                  }}
                />
              </span>
            </Styled.MobileInfo>
          </Styled.LabelContainer>
        </Styled.BannerMobile>
      </Styled.BannerMobileContainer>
    </Styled.EditBarMobile>
  );
};
